module.exports = __webpack_public_path__ + "img/feature-1.88154732.png";